import { Grid, Box, TextField } from "@mui/material";
import colors from "../../../../colors";
import DateRangePicker from "@mui/lab/DateRangePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import React from "react";

const DateRange = ({ dateRange, onChange }) => {

  return (
    <Grid
      item
      md={4}
      xs={12}
      justifyContent={"center"}
      alignItems={"center"}
      mt={0.5}
    >
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DateRangePicker
          inputFormat="dd/MM/yyyy"
          startText="Data fillimit"
          endText="Data mbarimit"
          value={dateRange}
          onChange={onChange}
          renderInput={(startProps, endProps) => (
            <React.Fragment>
              <TextField
                {...startProps}
                variant="outlined"
                size={"small"}
                color={"warning"}
                sx={{
                  background: colors.cyan,
                  borderRadius: "10px",
                  [`& fieldset`]: {
                    borderColor: colors.cyan,
                    borderRadius: "10px",
                  },
                }}
              />
              <Box sx={{ mx: 2 }}> në</Box>
              <TextField
                {...endProps}
                variant="outlined"
                size={"small"}
                color={"warning"}
                sx={{
                  background: colors.cyan,
                  borderRadius: "10px",
                  [`& fieldset`]: {
                    borderColor: colors.cyan,
                    borderRadius: "10px",
                  },
                }}
              />
            </React.Fragment>
          )}
        />
      </LocalizationProvider>
    </Grid>
  );
};

export default DateRange;
